import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, vModelText as _vModelText, withModifiers as _withModifiers, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53a69c1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-todo-head" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "nge-todo-icon",
  viewBox: "0 0 16 16",
  width: "14",
  height: "14",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "2",
    y: "2",
    width: "12",
    height: "12",
    rx: "3",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5 8.2l2 2 4-4.4",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "1.8",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-todo-sub" }, "Our own planning, apart from player reports. Type @ to tag an admin: they get the bell in Pyr and a ping in Slack. Start a checklist item with @name to make it theirs. Paste a picture anywhere.", -1 /* HOISTED */))
const _hoisted_4 = ["disabled", "title"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "nge-todo-mytasks-n"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "nge-todo-mytasks-panel"
}
const _hoisted_9 = { class: "nge-todo-mytasks-head" }
const _hoisted_10 = {
  key: 0,
  class: "nge-todo-mytasks-empty"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "nge-todo-mytask-kind" }
const _hoisted_14 = { class: "nge-todo-mytask-text" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "nge-todo-stats",
  "aria-label": "Board numbers"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "nge-todo-stat nge-todo-stat--todo" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "to do", -1 /* HOISTED */))
const _hoisted_20 = { class: "nge-todo-stat nge-todo-stat--doing" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "doing", -1 /* HOISTED */))
const _hoisted_22 = { class: "nge-todo-stat nge-todo-stat--done" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "done this week", -1 /* HOISTED */))
const _hoisted_24 = {
  key: 0,
  class: "nge-todo-stat nge-todo-stat--late"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "overdue", -1 /* HOISTED */))
const _hoisted_26 = {
  key: 1,
  class: "nge-todo-stat"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "days to done, on average", -1 /* HOISTED */))
const _hoisted_28 = {
  key: 2,
  class: "nge-todo-stat nge-todo-stat--people"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-todo-stat-word" }, "done this week", -1 /* HOISTED */))
const _hoisted_30 = {
  key: 2,
  class: "nge-todo-cheer",
  role: "status"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 3,
  class: "nge-todo-error",
  role: "alert"
}
const _hoisted_33 = {
  key: 4,
  class: "nge-todo-empty"
}
const _hoisted_34 = {
  key: 5,
  class: "nge-todo-body"
}
const _hoisted_35 = ["onDragover", "onDrop"]
const _hoisted_36 = ["title", "onClick"]
const _hoisted_37 = { class: "nge-todo-list-icon" }
const _hoisted_38 = { class: "nge-todo-list-title" }
const _hoisted_39 = { class: "nge-todo-count" }
const _hoisted_40 = ["title", "onClick"]
const _hoisted_41 = ["title", "onClick"]
const _hoisted_42 = { class: "nge-todo-list-icon" }
const _hoisted_43 = { class: "nge-todo-list-title" }
const _hoisted_44 = { class: "nge-todo-count" }
const _hoisted_45 = {
  key: 0,
  class: "nge-todo-sizes",
  title: "Sizes waiting in To do"
}
const _hoisted_46 = { class: "nge-todo-list-hint" }
const _hoisted_47 = ["title"]
const _hoisted_48 = ["onSubmit"]
const _hoisted_49 = {
  key: 1,
  class: "nge-todo-add"
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onSubmit"]
const _hoisted_52 = {
  class: "nge-todo-fmtbar",
  role: "toolbar",
  "aria-label": "Formatting"
}
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "B", -1 /* HOISTED */))
const _hoisted_54 = [
  _hoisted_53
]
const _hoisted_55 = {
  key: 0,
  class: "nge-todo-check"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "checkbox",
  disabled: ""
}, null, -1 /* HOISTED */))
const _hoisted_57 = ["onClick"]
const _hoisted_58 = {
  key: 1,
  class: "nge-todo-images"
}
const _hoisted_59 = ["src"]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 0,
  class: "nge-todo-warn"
}
const _hoisted_62 = {
  key: 2,
  class: "nge-todo-links"
}
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 3,
  class: "nge-todo-row nge-todo-linkform"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Guess from the address", -1 /* HOISTED */))
const _hoisted_66 = ["value"]
const _hoisted_67 = ["onKeydown"]
const _hoisted_68 = { class: "nge-todo-row" }
const _hoisted_69 = {
  class: "nge-todo-sizepick",
  role: "radiogroup",
  "aria-label": "Size"
}
const _hoisted_70 = ["aria-checked", "title", "onClick"]
const _hoisted_71 = ["value"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Owner (optional)", -1 /* HOISTED */))
const _hoisted_73 = ["value"]
const _hoisted_74 = { class: "nge-todo-row" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = ["onClick", "onKeydown", "onDragstart", "onDragover"]
const _hoisted_77 = ["onClick"]
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = ["src"]
const _hoisted_81 = { class: "nge-todo-card-title" }
const _hoisted_82 = ["title"]
const _hoisted_83 = ["title"]
const _hoisted_84 = {
  key: 3,
  class: "nge-todo-card-status"
}
const _hoisted_85 = {
  key: 4,
  class: "nge-todo-card-excerpt"
}
const _hoisted_86 = ["href", "title"]
const _hoisted_87 = { class: "nge-todo-card-meta" }
const _hoisted_88 = ["title"]
const _hoisted_89 = ["title"]
const _hoisted_90 = {
  key: 2,
  class: "nge-todo-chip",
  title: "Images"
}
const _hoisted_91 = {
  key: 3,
  class: "nge-todo-chip",
  title: "Comments"
}
const _hoisted_92 = {
  key: 4,
  class: "nge-todo-chip",
  title: "Made from a player report"
}
const _hoisted_93 = ["title"]
const _hoisted_94 = { class: "nge-todo-card-by" }
const _hoisted_95 = {
  key: 6,
  class: "nge-todo-waiting"
}
const _hoisted_96 = {
  key: 2,
  class: "nge-todo-drop-end"
}
const _hoisted_97 = {
  key: 3,
  class: "nge-todo-list-empty"
}
const _hoisted_98 = ["src"]
const _hoisted_99 = {
  key: 1,
  class: "nge-todo-panel",
  "aria-label": "Connect your AI"
}
const _hoisted_100 = { class: "nge-todo-panel-top" }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-todo-heading" }, "🔌 Connect your AI", -1 /* HOISTED */))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-notes" }, "Let your own Claude or ChatGPT read and work this board: list cards, add them, move them, tick checklists, comment and tag. Everything it writes is signed with your name and \"(via AI)\". It cannot delete cards.", -1 /* HOISTED */))
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-label" }, "Your private address", -1 /* HOISTED */))
const _hoisted_104 = { class: "nge-todo-key" }
const _hoisted_105 = { class: "nge-todo-row" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-warn" }, "Shown only now. Keep it to yourself: anyone with it can work the board as you. If it leaks, make a new one here.", -1 /* HOISTED */))
const _hoisted_107 = {
  key: 1,
  class: "nge-todo-notes"
}
const _hoisted_108 = { class: "nge-todo-row" }
const _hoisted_109 = ["disabled"]
const _hoisted_110 = ["disabled"]
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-label" }, "In Claude", -1 /* HOISTED */))
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "nge-todo-steps" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Settings, then Connectors, then Add custom connector."),
  /*#__PURE__*/_createElementVNode("li", null, "Name it \"Pyr To do board\" and paste your address. Leave the advanced settings empty."),
  /*#__PURE__*/_createElementVNode("li", null, "In a chat, turn it on from the tools menu, then ask, for example, \"What's on my plate on the Pyr To do board?\"")
], -1 /* HOISTED */))
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-label" }, "In ChatGPT", -1 /* HOISTED */))
const _hoisted_114 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", { class: "nge-todo-steps" }, [
  /*#__PURE__*/_createElementVNode("li", null, "Not every plan can add custom connectors. Where yours can, add one in ChatGPT's settings with your address and no sign in.")
], -1 /* HOISTED */))
const _hoisted_115 = {
  key: 2,
  class: "nge-todo-strip",
  "aria-label": "All cards"
}
const _hoisted_116 = { class: "nge-todo-count" }
const _hoisted_117 = ["aria-current", "onClick"]
const _hoisted_118 = { class: "nge-todo-strip-title" }
const _hoisted_119 = { class: "nge-todo-strip-meta" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = {
  key: 2,
  class: "nge-todo-avatar nge-todo-avatar--small"
}
const _hoisted_122 = {
  key: 0,
  class: "nge-todo-strip-empty"
}
const _hoisted_123 = {
  key: 3,
  class: "nge-todo-focus"
}
const _hoisted_124 = { class: "nge-todo-panel-top" }
const _hoisted_125 = ["title"]
const _hoisted_126 = ["value"]
const _hoisted_127 = ["value"]
const _hoisted_128 = ["disabled", "title"]
const _hoisted_129 = {
  key: 0,
  class: "nge-todo-follow-n"
}
const _hoisted_130 = ["href"]
const _hoisted_131 = { class: "nge-todo-field" }
const _hoisted_132 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-todo-label" }, "Size", -1 /* HOISTED */))
const _hoisted_133 = {
  class: "nge-todo-sizepick",
  role: "radiogroup",
  "aria-label": "Size"
}
const _hoisted_134 = ["aria-checked", "title", "onClick"]
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-todo-label" }, "Owner", -1 /* HOISTED */))
const _hoisted_136 = ["value"]
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Nobody yet", -1 /* HOISTED */))
const _hoisted_138 = ["value"]
const _hoisted_139 = { class: "nge-todo-row" }
const _hoisted_140 = ["title"]
const _hoisted_141 = { class: "nge-todo-field" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nge-todo-label" }, "Due", -1 /* HOISTED */))
const _hoisted_143 = ["value"]
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-label" }, "Links", -1 /* HOISTED */))
const _hoisted_145 = {
  key: 1,
  class: "nge-todo-links"
}
const _hoisted_146 = ["href", "title"]
const _hoisted_147 = ["onClick"]
const _hoisted_148 = {
  key: 2,
  class: "nge-todo-row nge-todo-linkform"
}
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Guess from the address", -1 /* HOISTED */))
const _hoisted_150 = ["value"]
const _hoisted_151 = { class: "nge-todo-label nge-todo-label-row" }
const _hoisted_152 = {
  class: "nge-todo-fmtbar",
  role: "toolbar",
  "aria-label": "Formatting"
}
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "B", -1 /* HOISTED */))
const _hoisted_154 = [
  _hoisted_153
]
const _hoisted_155 = { class: "nge-todo-row" }
const _hoisted_156 = ["innerHTML"]
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-label" }, "Images", -1 /* HOISTED */))
const _hoisted_158 = { class: "nge-todo-images" }
const _hoisted_159 = ["href"]
const _hoisted_160 = ["src"]
const _hoisted_161 = ["onClick"]
const _hoisted_162 = {
  key: 0,
  class: "nge-todo-warn"
}
const _hoisted_163 = { class: "nge-todo-label" }
const _hoisted_164 = { class: "nge-todo-check" }
const _hoisted_165 = ["checked", "onChange"]
const _hoisted_166 = ["title"]
const _hoisted_167 = {
  key: 0,
  class: "nge-todo-tag"
}
const _hoisted_168 = ["value", "onChange"]
const _hoisted_169 = { value: "" }
const _hoisted_170 = ["value"]
const _hoisted_171 = ["value", "onChange"]
const _hoisted_172 = ["onClick"]
const _hoisted_173 = ["onClick"]
const _hoisted_174 = ["disabled"]
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-todo-label" }, "Comments", -1 /* HOISTED */))
const _hoisted_176 = { class: "nge-todo-comment-by" }
const _hoisted_177 = { class: "nge-todo-notes" }
const _hoisted_178 = ["href"]
const _hoisted_179 = {
  key: 1,
  class: "nge-todo-tag"
}
const _hoisted_180 = {
  key: 9,
  class: "nge-todo-tagging"
}
const _hoisted_181 = { class: "nge-todo-row" }
const _hoisted_182 = ["disabled"]
const _hoisted_183 = {
  key: 0,
  class: "nge-todo-sent"
}
const _hoisted_184 = { class: "nge-todo-foot" }
const _hoisted_185 = ["aria-selected", "onMousedown"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nge-todo", { 'nge-todo--light': $props.light }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "nge-todo-btn",
        onClick: _cache[0] || (_cache[0] = $event => ($setup.emit('back'))),
        title: "Back to the triage board"
      }, "← Triage"),
      _createElementVNode("span", {
        class: "nge-todo-heading nge-todo-heading--home",
        title: "Back to the board",
        onClick: _cache[1] || (_cache[1] = $event => ($setup.openId = null))
      }, [
        _hoisted_2,
        _createTextVNode(" To do board")
      ]),
      _hoisted_3,
      _createElementVNode("button", {
        class: _normalizeClass(["nge-todo-btn nge-todo-mine", { 'nge-todo-mine--on': $setup.mineOnly }]),
        disabled: !$setup.myId,
        onClick: $setup.toggleMine,
        title: $setup.myId ? 'Only cards you own, are tagged on, or have checklist items on' : 'Your Pyr name is not on the board yet'
      }, _toDisplayString($setup.mineOnly ? '★ Mine' : '☆ Mine'), 11 /* TEXT, CLASS, PROPS */, _hoisted_4),
      _createElementVNode("button", {
        class: _normalizeClass(["nge-todo-btn nge-todo-mytasks", { 'nge-todo-mine--on': $setup.myTasksOpen }]),
        disabled: !$setup.myId,
        onClick: _cache[2] || (_cache[2] = $event => {$setup.myTasksOpen = !$setup.myTasksOpen; $setup.openId = null}),
        title: "Everything that is yours: cards you own and checklist items for you, by due day"
      }, [
        _createTextVNode("📌 My Tasks"),
        ($setup.myTaskCount)
          ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString($setup.myTaskCount), 1 /* TEXT */))
          : _createCommentVNode("v-if", true)
      ], 10 /* CLASS, PROPS */, _hoisted_5),
      _createElementVNode("button", {
        class: "nge-todo-btn",
        onClick: $setup.openConnect,
        title: "Let your own Claude or ChatGPT work this board"
      }, "🔌 Connect your AI"),
      _createElementVNode("button", {
        class: "nge-todo-btn",
        disabled: $setup.loading,
        onClick: $setup.load
      }, _toDisplayString($setup.loading ? 'Loading…' : '↻ Refresh'), 9 /* TEXT, PROPS */, _hoisted_7)
    ]),
    ($setup.myTasksOpen && !$setup.openCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createTextVNode("📌 My Tasks "),
            _createElementVNode("span", null, _toDisplayString($setup.myTaskCount) + " open", 1 /* TEXT */)
          ]),
          (!$setup.myTaskCount)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("img", {
                  src: $setup.imgNurroHome,
                  alt: ""
                }, null, 8 /* PROPS */, _hoisted_11),
                _createTextVNode("Nothing is yours right now. Enjoy it!")
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.myTasks, (g) => {
            return (_openBlock(), _createElementBlock("section", {
              key: g.head,
              class: "nge-todo-mytasks-group"
            }, [
              _createElementVNode("h4", {
                class: _normalizeClass({ 'nge-todo-mytasks-late': g.late })
              }, _toDisplayString(g.head) + " · " + _toDisplayString(g.rows.length), 3 /* TEXT, CLASS */),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.rows, (t) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: t.key,
                  type: "button",
                  class: "nge-todo-mytask",
                  onClick: $event => ($setup.openTask(t))
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(t.item === null ? '▣' : '☐'), 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_14, [
                    _createTextVNode(_toDisplayString(t.text), 1 /* TEXT */),
                    (t.item !== null)
                      ? (_openBlock(), _createElementBlock("small", _hoisted_15, " in " + _toDisplayString(t.card.title), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  (t.due)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass(["nge-todo-mytask-due", { 'nge-todo-mytasks-late': g.late }])
                      }, _toDisplayString($setup.dueWords(t.due)), 3 /* TEXT, CLASS */))
                    : _createCommentVNode("v-if", true)
                ], 8 /* PROPS */, _hoisted_12))
              }), 128 /* KEYED_FRAGMENT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    (!$setup.openCard && !$setup.notInstalled && !$setup.myTasksOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("img", {
            src: $setup.imgNurroHome,
            alt: "",
            class: "nge-todo-nurro"
          }, null, 8 /* PROPS */, _hoisted_17),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("b", null, _toDisplayString($setup.stats.todo), 1 /* TEXT */),
            _hoisted_19
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("b", null, _toDisplayString($setup.stats.doing), 1 /* TEXT */),
            _hoisted_21
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("b", null, _toDisplayString($setup.stats.doneWeek), 1 /* TEXT */),
            _hoisted_23
          ]),
          ($setup.stats.late)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("b", null, _toDisplayString($setup.stats.late), 1 /* TEXT */),
                _hoisted_25
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.stats.avgDays !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                _createElementVNode("b", null, _toDisplayString($setup.stats.avgDays), 1 /* TEXT */),
                _hoisted_27
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.stats.byPerson.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stats.byPerson, (p) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: p.id,
                    class: "nge-todo-personstat",
                    style: _normalizeStyle({ '--pc': $setup.colorOf(p.id) })
                  }, [
                    _createTextVNode(_toDisplayString(p.name) + " ", 1 /* TEXT */),
                    _createElementVNode("b", null, _toDisplayString(p.n), 1 /* TEXT */)
                  ], 4 /* STYLE */))
                }), 128 /* KEYED_FRAGMENT */)),
                _hoisted_29
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.party)
        ? (_openBlock(), _createElementBlock("div", {
            key: $setup.party.key,
            class: "nge-todo-party",
            "aria-hidden": "true",
            style: _normalizeStyle({ left: $setup.party.x + 'px', top: $setup.party.y + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.party.bits, (b, i) => {
              return (_openBlock(), _createElementBlock("i", {
                key: i,
                class: _normalizeClass([{ 'nge-todo-party-bit--wide': b.wide }, "nge-todo-party-bit"]),
                style: _normalizeStyle({ background: b.c, '--dx': b.dx + 'px', '--dy': b.dy + 'px', '--r': b.r + 'deg', animationDuration: b.d + 's' })
              }, null, 6 /* CLASS, STYLE */))
            }), 128 /* KEYED_FRAGMENT */))
          ], 4 /* STYLE */))
        : _createCommentVNode("v-if", true)
    ])),
    ($setup.nurroCheer)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          _createElementVNode("img", {
            src: $setup.imgNurroBravo,
            alt: ""
          }, null, 8 /* PROPS */, _hoisted_31),
          _createElementVNode("span", null, _toDisplayString($setup.nurroCheer), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createTextVNode("⚠ " + _toDisplayString($setup.error) + " ", 1 /* TEXT */),
          _createElementVNode("button", {
            class: "nge-todo-x",
            onClick: _cache[3] || (_cache[3] = $event => ($setup.error = '')),
            "aria-label": "Close"
          }, "×")
        ]))
      : _createCommentVNode("v-if", true),
    ($setup.notInstalled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, "The To do board needs its table: run supabase-admin-todos.sql in the Supabase SQL editor, then Refresh."))
      : (_openBlock(), _createElementBlock("div", _hoisted_34, [
          (!$setup.openCard && !$setup.myTasksOpen)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "nge-todo-lists",
                style: _normalizeStyle({ gridTemplateColumns: $setup.listColumns })
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.columns, (col) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: col.key,
                    class: _normalizeClass(["nge-todo-list", [`nge-todo-list--${col.key}`, { 'nge-todo-list--folded': $setup.isFolded(col.key) }]]),
                    onDragover: $event => ($setup.onDragOverList($event, col.key)),
                    onDrop: $event => ($setup.onDrop($event, col.key))
                  }, [
                    ($setup.isFolded(col.key))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-todo-rail",
                          title: 'Open ' + col.title,
                          onClick: $event => ($setup.toggleFold(col.key))
                        }, [
                          _createElementVNode("span", _hoisted_37, _toDisplayString($setup.LIST_ICONS[col.key]), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_38, _toDisplayString(col.title), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_39, _toDisplayString(col.rows.length), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_36))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("header", {
                            class: "nge-todo-list-head nge-todo-list-head--fold",
                            title: 'Click to fold ' + col.title + ' away',
                            onClick: $event => ($setup.onHeadClick($event, col.key))
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "nge-todo-mini nge-todo-fold",
                              title: 'Fold ' + col.title + ' away',
                              onClick: $event => ($setup.toggleFold(col.key))
                            }, "◂", 8 /* PROPS */, _hoisted_41),
                            _createElementVNode("span", _hoisted_42, _toDisplayString($setup.LIST_ICONS[col.key]), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_43, _toDisplayString(col.title), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_44, _toDisplayString(col.rows.length), 1 /* TEXT */),
                            (col.key === 'todo' && $setup.sizeSummary.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sizeSummary, (x, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                      key: x.s
                                    }, [
                                      _createTextVNode(_toDisplayString(i ? ' · ' : '') + _toDisplayString(x.n) + " " + _toDisplayString(x.s), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true),
                            _createElementVNode("span", _hoisted_46, _toDisplayString(col.hint), 1 /* TEXT */),
                            (col.key === 'todo')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  type: "button",
                                  class: "nge-todo-mini nge-todo-sort",
                                  title: $setup.todoByDue ? 'Showing by due day. Click for your own order.' : 'Showing your own order. Click to sort by due day.',
                                  onClick: $setup.toggleTodoSort
                                }, _toDisplayString($setup.todoByDue ? '⇅ By due day' : '⇅ My order'), 9 /* TEXT, PROPS */, _hoisted_47))
                              : _createCommentVNode("v-if", true)
                          ], 8 /* PROPS */, _hoisted_40),
                          (col.key === 'todo')
                            ? (_openBlock(), _createElementBlock("form", {
                                key: 0,
                                class: "nge-todo-quick",
                                onSubmit: _withModifiers($setup.quickAdd, ["prevent"])
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.quick) = $event)),
                                  class: "nge-todo-input",
                                  maxlength: "200",
                                  placeholder: "Quick add: type and press Enter",
                                  "aria-label": "Quick add a card",
                                  onInput: _cache[5] || (_cache[5] = $event => ($setup.onMentionInput($event, v => $setup.quick = v))),
                                  onKeydown: $setup.onMentionKey,
                                  onKeyup: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
                                  onKeypress: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                  [_vModelText, $setup.quick]
                                ])
                              ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_48))
                            : _createCommentVNode("v-if", true),
                          (col.key !== 'done')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                ($setup.adding !== col.key)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      class: "nge-todo-btn nge-todo-add-btn",
                                      onClick: $event => {$setup.adding = col.key; $setup.draft = $setup.newDraft(); $setup.linkDraft = null}
                                    }, "＋ Add a card", 8 /* PROPS */, _hoisted_50))
                                  : (_openBlock(), _createElementBlock("form", {
                                      key: 1,
                                      class: "nge-todo-form",
                                      onSubmit: _withModifiers($event => ($setup.addCard(col.key)), ["prevent"])
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (($setup.draft.title) = $event)),
                                        class: "nge-todo-input",
                                        maxlength: "200",
                                        placeholder: "What needs doing",
                                        "aria-label": "Title",
                                        onInput: _cache[9] || (_cache[9] = $event => ($setup.onMentionInput($event, v => $setup.draft.title = v))),
                                        onKeydown: $setup.onMentionKey,
                                        onKeyup: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"])),
                                        onKeypress: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelText, $setup.draft.title]
                                      ]),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => (($setup.draft.status) = $event)),
                                        class: "nge-todo-input nge-todo-status-input",
                                        maxlength: "200",
                                        placeholder: "Status, in a line (optional)",
                                        "aria-label": "Status",
                                        onKeydown: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                                        onKeyup: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"])),
                                        onKeypress: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [_vModelText, $setup.draft.status]
                                      ]),
                                      _createElementVNode("div", _hoisted_52, [
                                        _createElementVNode("button", {
                                          type: "button",
                                          title: "Bold",
                                          onClick: _cache[16] || (_cache[16] = $event => ($setup.fmtBold($setup.draftBox)))
                                        }, _hoisted_54),
                                        _createElementVNode("button", {
                                          type: "button",
                                          title: "Bulleted list",
                                          onClick: _cache[17] || (_cache[17] = $event => ($setup.fmtList($setup.draftBox, false)))
                                        }, "• Bullets"),
                                        _createElementVNode("button", {
                                          type: "button",
                                          title: "Numbered list",
                                          onClick: _cache[18] || (_cache[18] = $event => ($setup.fmtList($setup.draftBox, true)))
                                        }, "1. Numbers"),
                                        _createElementVNode("button", {
                                          type: "button",
                                          title: "Select some lines, then click: they become checklist items",
                                          onClick: $setup.draftToChecklist
                                        }, "☑ Checklist"),
                                        _createElementVNode("button", {
                                          type: "button",
                                          title: "Add an image. You can also paste or drop one into the notes.",
                                          onClick: _cache[19] || (_cache[19] = $event => ($setup.pickImages('new')))
                                        }, "🖼 Image")
                                      ]),
                                      _withDirectives(_createElementVNode("textarea", {
                                        ref_for: true,
                                        ref: $setup.setDraftNotesEl,
                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => (($setup.draft.notes) = $event)),
                                        class: "nge-todo-input",
                                        rows: "4",
                                        maxlength: "8000",
                                        placeholder: "Notes (optional). Type @ to tag someone. Select lines and click Checklist to turn them into items.",
                                        "aria-label": "Notes",
                                        onInput: _cache[21] || (_cache[21] = $event => ($setup.onMentionInput($event, v => $setup.draft.notes = v))),
                                        onKeydown: $setup.onMentionKey,
                                        onKeyup: _cache[22] || (_cache[22] = _withModifiers(() => {}, ["stop"])),
                                        onKeypress: _cache[23] || (_cache[23] = _withModifiers(() => {}, ["stop"])),
                                        "data-nge-notes-paste": "",
                                        onPaste: _cache[24] || (_cache[24] = $event => ($setup.onNotesPaste($event, 'new'))),
                                        onDragover: _cache[25] || (_cache[25] = _withModifiers(() => {}, ["prevent"])),
                                        onDrop: _cache[26] || (_cache[26] = $event => ($setup.onNotesDrop($event, 'new')))
                                      }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                                        [$setup["vAutogrow"]],
                                        [_vModelText, $setup.draft.notes]
                                      ]),
                                      ($setup.draft.checklist.length)
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_55, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draft.checklist, (it, i) => {
                                              return (_openBlock(), _createElementBlock("li", { key: i }, [
                                                _createElementVNode("label", null, [
                                                  _hoisted_56,
                                                  _createTextVNode(),
                                                  _createElementVNode("span", null, _toDisplayString(it.text), 1 /* TEXT */)
                                                ]),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "nge-todo-mini",
                                                  "aria-label": "Remove",
                                                  onClick: $event => ($setup.draft.checklist.splice(i, 1))
                                                }, "×", 8 /* PROPS */, _hoisted_57)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.draft.images.length || $setup.imageBusy)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draft.images, (u, i) => {
                                              return (_openBlock(), _createElementBlock("span", {
                                                key: u,
                                                class: "nge-todo-image"
                                              }, [
                                                _createElementVNode("img", {
                                                  src: u,
                                                  alt: ""
                                                }, null, 8 /* PROPS */, _hoisted_59),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "nge-todo-image-x",
                                                  "aria-label": "Remove image",
                                                  onClick: $event => ($setup.draft.images.splice(i, 1))
                                                }, "×", 8 /* PROPS */, _hoisted_60)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */)),
                                            ($setup.imageBusy)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, "Uploading…"))
                                              : _createCommentVNode("v-if", true)
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.draft.links.length)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draft.links, (l, i) => {
                                              return (_openBlock(), _createElementBlock("span", {
                                                key: i,
                                                class: "nge-todo-linkchip"
                                              }, [
                                                _createTextVNode(_toDisplayString($setup.linkIcon(l)) + " " + _toDisplayString($setup.linkWord(l)), 1 /* TEXT */),
                                                _createElementVNode("button", {
                                                  type: "button",
                                                  class: "nge-todo-mini",
                                                  "aria-label": "Remove link",
                                                  onClick: $event => ($setup.draft.links.splice(i, 1))
                                                }, "×", 8 /* PROPS */, _hoisted_63)
                                              ]))
                                            }), 128 /* KEYED_FRAGMENT */))
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      ($setup.linkDraft?.for === 'new')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                            _withDirectives(_createElementVNode("select", {
                                              "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => (($setup.linkDraft.kind) = $event)),
                                              class: "nge-todo-select",
                                              "aria-label": "Kind of link"
                                            }, [
                                              _hoisted_65,
                                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.LINK_KINDS, (k) => {
                                                return _createElementVNode("option", {
                                                  key: k.key,
                                                  value: k.key
                                                }, _toDisplayString(k.icon) + " " + _toDisplayString(k.word), 9 /* TEXT, PROPS */, _hoisted_66)
                                              }), 64 /* STABLE_FRAGMENT */))
                                            ], 512 /* NEED_PATCH */), [
                                              [_vModelSelect, $setup.linkDraft.kind]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => (($setup.linkDraft.url) = $event)),
                                              class: "nge-todo-input nge-todo-grow",
                                              placeholder: "https://...",
                                              "aria-label": "Address",
                                              onKeydown: [
                                                _cache[29] || (_cache[29] = _withModifiers(() => {}, ["stop"])),
                                                _withKeys(_withModifiers($setup.addDraftLink, ["prevent"]), ["enter"])
                                              ],
                                              onKeyup: _cache[30] || (_cache[30] = _withModifiers(() => {}, ["stop"])),
                                              onKeypress: _cache[31] || (_cache[31] = _withModifiers(() => {}, ["stop"]))
                                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_67), [
                                              [_vModelText, $setup.linkDraft.url]
                                            ]),
                                            ($setup.linkDraft.kind === 'other')
                                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                                  key: 0,
                                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => (($setup.linkDraft.label) = $event)),
                                                  class: "nge-todo-input nge-todo-short",
                                                  maxlength: "40",
                                                  placeholder: "Name",
                                                  "aria-label": "Link name",
                                                  onKeydown: _cache[33] || (_cache[33] = _withModifiers(() => {}, ["stop"])),
                                                  onKeyup: _cache[34] || (_cache[34] = _withModifiers(() => {}, ["stop"])),
                                                  onKeypress: _cache[35] || (_cache[35] = _withModifiers(() => {}, ["stop"]))
                                                }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)), [
                                                  [_vModelText, $setup.linkDraft.label]
                                                ])
                                              : _createCommentVNode("v-if", true),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "nge-todo-btn",
                                              onClick: $setup.addDraftLink
                                            }, "Add link"),
                                            _createElementVNode("button", {
                                              type: "button",
                                              class: "nge-todo-mini",
                                              onClick: _cache[36] || (_cache[36] = $event => ($setup.linkDraft = null))
                                            }, "Cancel")
                                          ]))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", _hoisted_68, [
                                        _createElementVNode("span", _hoisted_69, [
                                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SIZES, (s) => {
                                            return _createElementVNode("button", {
                                              key: s,
                                              type: "button",
                                              role: "radio",
                                              class: _normalizeClass(["nge-todo-size", { 'nge-todo-size--on': $setup.draft.size === s }]),
                                              "aria-checked": $setup.draft.size === s ? 'true' : 'false',
                                              title: $setup.SIZE_WORDS[s],
                                              onClick: $event => ($setup.draft.size = $setup.draft.size === s ? null : s)
                                            }, _toDisplayString(s), 11 /* TEXT, CLASS, PROPS */, _hoisted_70)
                                          }), 64 /* STABLE_FRAGMENT */))
                                        ]),
                                        _createElementVNode("select", {
                                          class: "nge-todo-select",
                                          value: $setup.draft.owner_id,
                                          "aria-label": "Owner",
                                          onChange: _cache[37] || (_cache[37] = $event => ($setup.onDraftOwner($event)))
                                        }, [
                                          _hoisted_72,
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.people, (p) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: p.id,
                                              value: p.id
                                            }, _toDisplayString(p.name), 9 /* TEXT, PROPS */, _hoisted_73))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_71),
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => (($setup.draft.due_on) = $event)),
                                          type: "date",
                                          class: "nge-todo-select",
                                          "aria-label": "Due day (optional)",
                                          title: "Due day (optional)"
                                        }, null, 512 /* NEED_PATCH */), [
                                          [_vModelText, $setup.draft.due_on]
                                        ]),
                                        ($setup.linkDraft?.for !== 'new')
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              type: "button",
                                              class: "nge-todo-btn",
                                              onClick: _cache[39] || (_cache[39] = $event => ($setup.linkDraft = { for: 'new', kind: '', url: '', label: '' }))
                                            }, "＋ Link"))
                                          : _createCommentVNode("v-if", true)
                                      ]),
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("button", {
                                          type: "submit",
                                          class: "nge-todo-btn nge-todo-btn--primary",
                                          disabled: $setup.busy || !!$setup.imageBusy || !$setup.draft.title.trim()
                                        }, _toDisplayString($setup.busy ? 'Adding…' : 'Add'), 9 /* TEXT, PROPS */, _hoisted_75),
                                        _createElementVNode("button", {
                                          type: "button",
                                          class: "nge-todo-btn",
                                          onClick: _cache[40] || (_cache[40] = $event => ($setup.adding = null))
                                        }, "Cancel")
                                      ])
                                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_51))
                              ]))
                            : _createCommentVNode("v-if", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.rows, (c) => {
                            return (_openBlock(), _createElementBlock("article", {
                              key: c.id,
                              class: _normalizeClass(["nge-todo-card", { 'nge-todo-card--open': $setup.openId === c.id, 'nge-todo-card--dragging': $setup.dragId === c.id, 'nge-todo-card--won': $setup.winning === c.id,
                             'nge-todo-card--drop-above': $setup.dropAt?.id === c.id && !$setup.dropAt.after, 'nge-todo-card--drop-below': $setup.dropAt?.id === c.id && $setup.dropAt.after }]),
                              draggable: "true",
                              tabindex: "0",
                              onClick: $event => ($setup.openUp(c)),
                              onKeydown: _withKeys($event => ($setup.openUp(c)), ["enter"]),
                              onDragstart: $event => ($setup.onDragStart($event, c)),
                              onDragend: $setup.onDragEnd,
                              onDragover: $event => ($setup.onDragOverCard($event, col.key, c))
                            }, [
                              _createElementVNode("div", {
                                class: "nge-todo-card-tools",
                                onClick: _cache[41] || (_cache[41] = _withModifiers(() => {}, ["stop"]))
                              }, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-todo-mini",
                                  title: "Edit",
                                  "aria-label": "Edit",
                                  onClick: $event => ($setup.editCard(c))
                                }, "✎", 8 /* PROPS */, _hoisted_77),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "nge-todo-mini",
                                  title: "Delete",
                                  "aria-label": "Delete",
                                  onClick: $event => ($setup.deleteCard(c))
                                }, "🗑", 8 /* PROPS */, _hoisted_78)
                              ]),
                              (c.list !== 'done')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "nge-todo-card-done",
                                    onClick: _cache[42] || (_cache[42] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "nge-todo-done-btn",
                                      title: "Move to Done",
                                      onClick: $event => ($setup.finish(c, $event))
                                    }, "✓ Done", 8 /* PROPS */, _hoisted_79)
                                  ]))
                                : _createCommentVNode("v-if", true),
                              ((c.images || []).length)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    class: "nge-todo-card-cover",
                                    src: c.images[0],
                                    alt: "",
                                    loading: "lazy"
                                  }, null, 8 /* PROPS */, _hoisted_80))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_81, _toDisplayString(c.title), 1 /* TEXT */),
                              ($setup.isLive(c) || $setup.buildBadges(c).length)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "nge-todo-badges",
                                    onClick: _cache[43] || (_cache[43] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    ($setup.isLive(c))
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "nge-todo-badge nge-todo-badge--live",
                                          title: c.status || 'Its test site build is in the live site'
                                        }, "✓ Live", 8 /* PROPS */, _hoisted_82))
                                      : _createCommentVNode("v-if", true),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.buildBadges(c), (b) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        key: b.url,
                                        class: _normalizeClass(["nge-todo-badge", 'nge-todo-badge--' + b.state]),
                                        title: b.title
                                      }, _toDisplayString(b.word), 11 /* TEXT, CLASS, PROPS */, _hoisted_83))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true),
                              (c.status)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, _toDisplayString(c.status), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              ($setup.excerpt(c.notes))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString($setup.excerpt(c.notes)), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              ((c.links || []).length)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 5,
                                    class: "nge-todo-links",
                                    onClick: _cache[44] || (_cache[44] = _withModifiers(() => {}, ["stop"]))
                                  }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.links, (l, i) => {
                                      return (_openBlock(), _createElementBlock("a", {
                                        key: i,
                                        class: "nge-todo-linkchip",
                                        href: l.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        title: l.url,
                                        draggable: "false"
                                      }, _toDisplayString($setup.linkIcon(l)) + " " + _toDisplayString($setup.linkWord(l)), 9 /* TEXT, PROPS */, _hoisted_86))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  ]))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("div", _hoisted_87, [
                                (c.due_on)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: _normalizeClass(["nge-todo-chip", { 'nge-todo-chip--late': $setup.isOverdue(c) }]),
                                      title: 'Due ' + c.due_on
                                    }, _toDisplayString($setup.dueWords(c.due_on)), 11 /* TEXT, CLASS, PROPS */, _hoisted_88))
                                  : _createCommentVNode("v-if", true),
                                (c.checklist.length && !$setup.perPerson(c).length)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 1,
                                      class: _normalizeClass(["nge-todo-chip", { 'nge-todo-chip--all': $setup.checkCount(c).done === $setup.checkCount(c).all }]),
                                      title: "Checklist"
                                    }, "☑ " + _toDisplayString($setup.checkCount(c).done) + "/" + _toDisplayString($setup.checkCount(c).all), 3 /* TEXT, CLASS */))
                                  : _createCommentVNode("v-if", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.perPerson(c), (pp) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: pp.id,
                                    class: _normalizeClass(["nge-todo-chip nge-todo-chip--person", { 'nge-todo-chip--all': pp.done === pp.all }]),
                                    style: _normalizeStyle({ '--pc': $setup.colorOf(pp.id) }),
                                    title: `${pp.name}: ${pp.done} of ${pp.all} done`
                                  }, _toDisplayString($setup.firstName(pp.name)) + " " + _toDisplayString(pp.done) + "/" + _toDisplayString(pp.all), 15 /* TEXT, CLASS, STYLE, PROPS */, _hoisted_89))
                                }), 128 /* KEYED_FRAGMENT */)),
                                ((c.images || []).length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_90, "🖼 " + _toDisplayString(c.images.length), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (c.comments.length)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_91, "💬 " + _toDisplayString(c.comments.length), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (c.triage_id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_92, _toDisplayString($setup.reportLabel(c.triage_id)), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (c.owner_id)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 5,
                                      class: "nge-todo-avatar",
                                      style: _normalizeStyle({ background: $setup.colorOf(c.owner_id) }),
                                      title: 'Owner: ' + $setup.nameOf(c.owner_id)
                                    }, _toDisplayString($setup.initialOf(c.owner_id)), 13 /* TEXT, STYLE, PROPS */, _hoisted_93))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("div", _hoisted_94, [
                                _createTextVNode(_toDisplayString(c.owner_id ? $setup.nameOf(c.owner_id) : (c.created_by || '')), 1 /* TEXT */),
                                (c.updated_at)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(" · " + _toDisplayString($setup.ago(c.updated_at)), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              ($setup.waitingOn(c).length)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_95, "Waiting on " + _toDisplayString($setup.waitingOn(c).map(p => $setup.firstName(p.name)).join(', ')), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true)
                            ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_76))
                          }), 128 /* KEYED_FRAGMENT */)),
                          ($setup.dropAt?.list === col.key && !$setup.dropAt.id)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_96))
                            : _createCommentVNode("v-if", true),
                          (!col.rows.length && !$setup.loading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                _createElementVNode("img", {
                                  src: $setup.imgNurroWhere,
                                  alt: "",
                                  class: "nge-todo-nurro-empty"
                                }, null, 8 /* PROPS */, _hoisted_98),
                                _createTextVNode(_toDisplayString($setup.mineOnly ? 'Nothing of yours here.' : col.empty), 1 /* TEXT */)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (col.key === 'done' && (col.hidden || $setup.showAllDone))
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                class: "nge-todo-btn nge-todo-more",
                                onClick: _cache[45] || (_cache[45] = $event => ($setup.showAllDone = !$setup.showAllDone))
                              }, _toDisplayString($setup.showAllDone ? `Hide finished more than ${$setup.DONE_DAYS} days ago` : `Show ${col.hidden} finished more than ${$setup.DONE_DAYS} days ago`), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ], 64 /* STABLE_FRAGMENT */))
                  ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_35))
                }), 128 /* KEYED_FRAGMENT */))
              ], 4 /* STYLE */))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Connect your AI: the same narrow side panel as an open card. "),
          ($setup.connectOpen && !$setup.openCard)
            ? (_openBlock(), _createElementBlock("aside", _hoisted_99, [
                _createElementVNode("div", _hoisted_100, [
                  _hoisted_101,
                  _createElementVNode("button", {
                    class: "nge-todo-x",
                    onClick: _cache[46] || (_cache[46] = $event => ($setup.connectOpen = false)),
                    "aria-label": "Close",
                    title: "Close (Esc)"
                  }, "×")
                ]),
                _hoisted_102,
                ($setup.connectUrl)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_103,
                      _createElementVNode("div", _hoisted_104, _toDisplayString($setup.connectUrl), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("button", {
                          class: "nge-todo-btn nge-todo-btn--primary",
                          onClick: $setup.copyConnectUrl
                        }, _toDisplayString($setup.connectCopied ? 'Copied' : 'Copy'), 1 /* TEXT */)
                      ]),
                      _hoisted_106
                    ], 64 /* STABLE_FRAGMENT */))
                  : ($setup.connect?.connected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                        _createTextVNode("You are connected since " + _toDisplayString($setup.ago($setup.connect.created_at || '')), 1 /* TEXT */),
                        ($setup.connect.last_used_at)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(", last used " + _toDisplayString($setup.ago($setup.connect.last_used_at)), 1 /* TEXT */)
                            ], 64 /* STABLE_FRAGMENT */))
                          : _createCommentVNode("v-if", true),
                        _createTextVNode(".")
                      ]))
                    : _createCommentVNode("v-if", true),
                _createElementVNode("div", _hoisted_108, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["nge-todo-btn", { 'nge-todo-btn--primary': !$setup.connect?.connected && !$setup.connectUrl }]),
                    disabled: $setup.connectBusy,
                    onClick: _cache[47] || (_cache[47] = $event => ($setup.makeConnectUrl()))
                  }, _toDisplayString($setup.connectBusy ? 'Working…' : $setup.connect?.connected ? 'Make a new address' : 'Make my address'), 11 /* TEXT, CLASS, PROPS */, _hoisted_109),
                  ($setup.connect?.connected)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "nge-todo-btn nge-todo-delete",
                        disabled: $setup.connectBusy,
                        onClick: _cache[48] || (_cache[48] = $event => ($setup.makeConnectUrl(true)))
                      }, "Switch off", 8 /* PROPS */, _hoisted_110))
                    : _createCommentVNode("v-if", true)
                ]),
                _hoisted_111,
                _hoisted_112,
                _hoisted_113,
                _hoisted_114
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Focus view (Ames 2026-10-22: \"why not have the card I clicked expand\n           and the work there?\"): the open card takes the middle of the\n           screen, and the lists shrink to a strip of titles on the left, so\n           another card is still one click away. Esc or Board goes back. "),
          ($setup.openCard)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_115, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.columns, (col) => {
                  return (_openBlock(), _createElementBlock("section", {
                    key: col.key,
                    class: "nge-todo-strip-list"
                  }, [
                    _createElementVNode("div", {
                      class: "nge-todo-strip-head nge-todo-heading--home",
                      title: "Back to the board",
                      onClick: _cache[49] || (_cache[49] = $event => ($setup.openId = null))
                    }, [
                      _createTextVNode(_toDisplayString(col.title) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_116, _toDisplayString(col.rows.length), 1 /* TEXT */)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(col.rows, (c) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: c.id,
                        type: "button",
                        class: _normalizeClass(["nge-todo-strip-card", { 'nge-todo-strip-card--on': c.id === $setup.openId }]),
                        "aria-current": c.id === $setup.openId ? 'true' : undefined,
                        onClick: $event => ($setup.openUp(c))
                      }, [
                        _createElementVNode("span", _hoisted_118, _toDisplayString(c.title), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_119, [
                          (c.checklist.length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_120, "☑ " + _toDisplayString($setup.checkCount(c).done) + "/" + _toDisplayString($setup.checkCount(c).all), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (c.due_on)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass({ 'nge-todo-strip-late': $setup.isOverdue(c) })
                              }, _toDisplayString($setup.dueWords(c.due_on)), 3 /* TEXT, CLASS */))
                            : _createCommentVNode("v-if", true),
                          (c.owner_id)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_121, _toDisplayString($setup.initialOf(c.owner_id)), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 10 /* CLASS, PROPS */, _hoisted_117))
                    }), 128 /* KEYED_FRAGMENT */)),
                    (!col.rows.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_122, _toDisplayString(col.empty), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.openCard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                (_openBlock(), _createElementBlock("aside", {
                  class: "nge-todo-panel nge-todo-panel--focus",
                  key: $setup.openCard.id,
                  "aria-label": "Card"
                }, [
                  _createElementVNode("div", _hoisted_124, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-todo-btn",
                      title: "Back to the board (Esc)",
                      onClick: _cache[50] || (_cache[50] = $event => ($setup.openId = null))
                    }, "← Board"),
                    _createElementVNode("button", {
                      type: "button",
                      class: "nge-todo-btn nge-todo-cardlink",
                      title: $setup.cardLink($setup.openCard),
                      onClick: _cache[51] || (_cache[51] = $event => ($setup.copyCardLink($setup.openCard)))
                    }, _toDisplayString($setup.linkCopied === $setup.openCard.id ? '✓ Link copied' : '🔗 Copy link to this card'), 9 /* TEXT, PROPS */, _hoisted_125),
                    _createElementVNode("select", {
                      class: "nge-todo-select",
                      value: $setup.openCard.list,
                      "aria-label": "List",
                      onChange: _cache[52] || (_cache[52] = $event => ($setup.onListChange($setup.openCard, $event)))
                    }, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.LISTS, (l) => {
                        return _createElementVNode("option", {
                          key: l.key,
                          value: l.key
                        }, _toDisplayString(l.title), 9 /* TEXT, PROPS */, _hoisted_127)
                      }), 64 /* STABLE_FRAGMENT */))
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_126),
                    ($setup.openCard.list !== 'done')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-todo-btn nge-todo-done-big",
                          onClick: _cache[53] || (_cache[53] = $event => ($setup.finish($setup.openCard, $event)))
                        }, "✓ Done"))
                      : _createCommentVNode("v-if", true),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(["nge-todo-btn nge-todo-follow", { 'nge-todo-follow--on': $setup.iFollow($setup.openCard) }]),
                      disabled: !$setup.myId,
                      onClick: _cache[54] || (_cache[54] = $event => ($setup.toggleFollow($setup.openCard))),
                      title: ($setup.followerNames($setup.openCard).length ? 'Following: ' + $setup.followerNames($setup.openCard).join(', ') + '. ' : '') + 'Followers get a bell in Pyr when this card changes.'
                    }, [
                      _createTextVNode(_toDisplayString($setup.iFollow($setup.openCard) ? '🔔 Following' : '🔕 Follow'), 1 /* TEXT */),
                      ($setup.followerNames($setup.openCard).length)
                        ? (_openBlock(), _createElementBlock("b", _hoisted_129, _toDisplayString($setup.followerNames($setup.openCard).length), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 10 /* CLASS, PROPS */, _hoisted_128)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    ref: "titleEl",
                    "onUpdate:modelValue": _cache[55] || (_cache[55] = $event => (($setup.editTitle) = $event)),
                    class: "nge-todo-input nge-todo-title-edit",
                    maxlength: "200",
                    "aria-label": "Title",
                    title: "Click to edit the title",
                    onInput: _cache[56] || (_cache[56] = $event => ($setup.onMentionInput($event, v => $setup.editTitle = v))),
                    onKeydown: $setup.onTitleKey,
                    onBlur: _cache[57] || (_cache[57] = $event => ($setup.saveTitle($setup.openCard))),
                    onKeyup: _cache[58] || (_cache[58] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[59] || (_cache[59] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.editTitle]
                  ]),
                  ($setup.openCard.triage_id)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "nge-todo-link",
                        href: $setup.reportHref($setup.openCard.triage_id),
                        target: "_blank",
                        rel: "noopener"
                      }, _toDisplayString($setup.reportLabel($setup.openCard.triage_id)) + ": open it on the triage board ↗", 9 /* TEXT, PROPS */, _hoisted_130))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_131, [
                    _hoisted_132,
                    _createElementVNode("span", _hoisted_133, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.SIZES, (s) => {
                        return _createElementVNode("button", {
                          key: s,
                          type: "button",
                          role: "radio",
                          class: _normalizeClass(["nge-todo-size", { 'nge-todo-size--on': $setup.openCard.size === s }]),
                          "aria-checked": $setup.openCard.size === s ? 'true' : 'false',
                          title: $setup.SIZE_WORDS[s],
                          onClick: $event => ($setup.save($setup.openCard, { size: $setup.openCard.size === s ? null : s }))
                        }, _toDisplayString(s), 11 /* TEXT, CLASS, PROPS */, _hoisted_134)
                      }), 64 /* STABLE_FRAGMENT */))
                    ]),
                    _hoisted_135,
                    _createElementVNode("select", {
                      class: "nge-todo-select",
                      value: $setup.openCard.owner_id || '',
                      "aria-label": "Owner",
                      onChange: _cache[60] || (_cache[60] = $event => ($setup.onOwnerChange($setup.openCard, $event)))
                    }, [
                      _hoisted_137,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.people, (p) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: p.id,
                          value: p.id
                        }, _toDisplayString(p.name), 9 /* TEXT, PROPS */, _hoisted_138))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_136)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[61] || (_cache[61] = $event => (($setup.editStatus) = $event)),
                    class: "nge-todo-input nge-todo-status-input",
                    maxlength: "200",
                    placeholder: "Status, in a line (optional)",
                    "aria-label": "Status",
                    onKeydown: [
                      _cache[62] || (_cache[62] = _withModifiers(() => {}, ["stop"])),
                      _cache[63] || (_cache[63] = _withKeys($event => ($setup.blurOf($event)), ["enter"]))
                    ],
                    onKeyup: _cache[64] || (_cache[64] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[65] || (_cache[65] = _withModifiers(() => {}, ["stop"])),
                    onBlur: _cache[66] || (_cache[66] = $event => ($setup.saveStatus($setup.openCard)))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [_vModelText, $setup.editStatus]
                  ]),
                  _createElementVNode("div", _hoisted_139, [
                    (!$setup.isLive($setup.openCard))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-todo-btn nge-todo-live-btn",
                          title: "Shipped straight to the live site: say so on the card",
                          onClick: _cache[67] || (_cache[67] = $event => ($setup.markLive($setup.openCard)))
                        }, "✓ Mark live"))
                      : _createCommentVNode("v-if", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.testLinks($setup.openCard).map(l => $setup.builds[l.url]).filter(Boolean), (b) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: b.url,
                        class: _normalizeClass(["nge-todo-badge", 'nge-todo-badge--' + b.state]),
                        title: b.title
                      }, _toDisplayString(b.word), 11 /* TEXT, CLASS, PROPS */, _hoisted_140))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("div", _hoisted_141, [
                    _hoisted_142,
                    _createElementVNode("input", {
                      type: "date",
                      class: "nge-todo-select",
                      value: $setup.openCard.due_on || '',
                      "aria-label": "Due day",
                      onChange: _cache[68] || (_cache[68] = $event => ($setup.onDueChange($setup.openCard, $event)))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_143),
                    ($setup.openCard.due_on)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-todo-mini",
                          onClick: _cache[69] || (_cache[69] = $event => ($setup.save($setup.openCard, { due_on: null })))
                        }, "Clear"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _hoisted_144,
                  (($setup.openCard.links || []).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_145, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.openCard.links, (l, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            class: "nge-todo-linkchip"
                          }, [
                            _createElementVNode("a", {
                              href: l.url,
                              target: "_blank",
                              rel: "noopener noreferrer",
                              title: l.url
                            }, _toDisplayString($setup.linkIcon(l)) + " " + _toDisplayString($setup.linkWord(l)), 9 /* TEXT, PROPS */, _hoisted_146),
                            _createElementVNode("button", {
                              type: "button",
                              class: "nge-todo-mini",
                              "aria-label": "Remove link",
                              onClick: $event => ($setup.removeCardLink($setup.openCard, i))
                            }, "×", 8 /* PROPS */, _hoisted_147)
                          ]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($setup.linkDraft?.for === $setup.openCard.id)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_148, [
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => (($setup.linkDraft.kind) = $event)),
                          class: "nge-todo-select",
                          "aria-label": "Kind of link"
                        }, [
                          _hoisted_149,
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.LINK_KINDS, (k) => {
                            return _createElementVNode("option", {
                              key: k.key,
                              value: k.key
                            }, _toDisplayString(k.icon) + " " + _toDisplayString(k.word), 9 /* TEXT, PROPS */, _hoisted_150)
                          }), 64 /* STABLE_FRAGMENT */))
                        ], 512 /* NEED_PATCH */), [
                          [_vModelSelect, $setup.linkDraft.kind]
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[71] || (_cache[71] = $event => (($setup.linkDraft.url) = $event)),
                          class: "nge-todo-input nge-todo-grow",
                          placeholder: "https://...",
                          "aria-label": "Address",
                          onKeydown: [
                            _cache[72] || (_cache[72] = _withModifiers(() => {}, ["stop"])),
                            _cache[75] || (_cache[75] = _withKeys(_withModifiers($event => ($setup.addCardLink($setup.openCard)), ["prevent"]), ["enter"]))
                          ],
                          onKeyup: _cache[73] || (_cache[73] = _withModifiers(() => {}, ["stop"])),
                          onKeypress: _cache[74] || (_cache[74] = _withModifiers(() => {}, ["stop"]))
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [_vModelText, $setup.linkDraft.url]
                        ]),
                        ($setup.linkDraft.kind === 'other')
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => (($setup.linkDraft.label) = $event)),
                              class: "nge-todo-input nge-todo-short",
                              maxlength: "40",
                              placeholder: "Name",
                              "aria-label": "Link name",
                              onKeydown: _cache[77] || (_cache[77] = _withModifiers(() => {}, ["stop"])),
                              onKeyup: _cache[78] || (_cache[78] = _withModifiers(() => {}, ["stop"])),
                              onKeypress: _cache[79] || (_cache[79] = _withModifiers(() => {}, ["stop"]))
                            }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */)), [
                              [_vModelText, $setup.linkDraft.label]
                            ])
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "nge-todo-btn",
                          onClick: _cache[80] || (_cache[80] = $event => ($setup.addCardLink($setup.openCard)))
                        }, "Add link"),
                        _createElementVNode("button", {
                          type: "button",
                          class: "nge-todo-mini",
                          onClick: _cache[81] || (_cache[81] = $event => ($setup.linkDraft = null))
                        }, "Cancel")
                      ]))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        type: "button",
                        class: "nge-todo-btn nge-todo-add-btn",
                        onClick: _cache[82] || (_cache[82] = $event => ($setup.linkDraft = { for: $setup.openCard.id, kind: '', url: '', label: '' }))
                      }, "＋ Link, like the test site")),
                  _createElementVNode("div", _hoisted_151, [
                    _createTextVNode("Notes "),
                    (!$setup.notesEditing && $setup.openCard.notes)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "nge-todo-mini",
                          onClick: _cache[83] || (_cache[83] = $event => ($setup.notesEditing = true))
                        }, "✎ Edit"))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.notesEditing)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _createElementVNode("div", _hoisted_152, [
                          _createElementVNode("button", {
                            type: "button",
                            title: "Bold",
                            onClick: _cache[84] || (_cache[84] = $event => ($setup.fmtBold($setup.cardBox)))
                          }, _hoisted_154),
                          _createElementVNode("button", {
                            type: "button",
                            title: "Bulleted list",
                            onClick: _cache[85] || (_cache[85] = $event => ($setup.fmtList($setup.cardBox, false)))
                          }, "• Bullets"),
                          _createElementVNode("button", {
                            type: "button",
                            title: "Numbered list",
                            onClick: _cache[86] || (_cache[86] = $event => ($setup.fmtList($setup.cardBox, true)))
                          }, "1. Numbers"),
                          _createElementVNode("button", {
                            type: "button",
                            title: "Select some lines, then click: they become checklist items",
                            onClick: _cache[87] || (_cache[87] = $event => ($setup.cardToChecklist($setup.openCard)))
                          }, "☑ Checklist"),
                          _createElementVNode("button", {
                            type: "button",
                            title: "Add an image. You can also paste or drop one into the notes.",
                            onClick: _cache[88] || (_cache[88] = $event => ($setup.pickImages($setup.openCard)))
                          }, "🖼 Image")
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          ref: "cardNotesEl",
                          "onUpdate:modelValue": _cache[89] || (_cache[89] = $event => (($setup.editNotes) = $event)),
                          class: "nge-todo-input",
                          rows: "7",
                          maxlength: "8000",
                          placeholder: "Type @ to tag someone. Select lines and click Checklist to turn them into items.",
                          "aria-label": "Notes",
                          onInput: _cache[90] || (_cache[90] = $event => ($setup.onMentionInput($event, v => $setup.editNotes = v))),
                          onKeydown: $setup.onMentionKey,
                          onKeyup: _cache[91] || (_cache[91] = _withModifiers(() => {}, ["stop"])),
                          onKeypress: _cache[92] || (_cache[92] = _withModifiers(() => {}, ["stop"])),
                          "data-nge-notes-paste": "",
                          onPaste: _cache[93] || (_cache[93] = $event => ($setup.onNotesPaste($event, $setup.openCard))),
                          onDragover: _cache[94] || (_cache[94] = _withModifiers(() => {}, ["prevent"])),
                          onDrop: _cache[95] || (_cache[95] = $event => ($setup.onNotesDrop($event, $setup.openCard)))
                        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                          [$setup["vAutogrow"]],
                          [_vModelText, $setup.editNotes]
                        ]),
                        _createElementVNode("div", _hoisted_155, [
                          _createElementVNode("button", {
                            class: "nge-todo-btn nge-todo-btn--primary",
                            onClick: _cache[96] || (_cache[96] = $event => {$setup.saveNotes($setup.openCard); $setup.notesEditing = false})
                          }, "Save notes"),
                          _createElementVNode("button", {
                            class: "nge-todo-btn",
                            onClick: _cache[97] || (_cache[97] = $event => {$setup.editNotes = $setup.openCard.notes; $setup.notesEditing = false})
                          }, "Cancel")
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : (!$setup.openCard.notes)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 5,
                          class: "nge-todo-btn nge-todo-add-btn",
                          onClick: _cache[98] || (_cache[98] = $event => ($setup.notesEditing = true))
                        }, "＋ Add notes"))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 6,
                          class: "nge-todo-notes nge-todo-notes--edit nge-todo-md",
                          title: "Click to edit",
                          onClick: _cache[99] || (_cache[99] = $event => ($setup.notesEditing = true)),
                          innerHTML: $setup.notesHtml($setup.openCard.notes)
                        }, null, 8 /* PROPS */, _hoisted_156)),
                  (($setup.openCard.images || []).length || $setup.imageBusy)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                        _hoisted_157,
                        _createElementVNode("div", _hoisted_158, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.openCard.images, (u, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: u,
                              class: "nge-todo-image"
                            }, [
                              _createElementVNode("a", {
                                href: u,
                                target: "_blank",
                                rel: "noopener",
                                title: "Open full size"
                              }, [
                                _createElementVNode("img", {
                                  src: u,
                                  alt: "",
                                  loading: "lazy"
                                }, null, 8 /* PROPS */, _hoisted_160)
                              ], 8 /* PROPS */, _hoisted_159),
                              _createElementVNode("button", {
                                type: "button",
                                class: "nge-todo-image-x",
                                "aria-label": "Remove image",
                                onClick: $event => ($setup.removeCardImage($setup.openCard, i))
                              }, "×", 8 /* PROPS */, _hoisted_161)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */)),
                          ($setup.imageBusy)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_162, "Uploading…"))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 64 /* STABLE_FRAGMENT */))
                    : _createCommentVNode("v-if", true),
                  (!$setup.notesEditing)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 8,
                        type: "button",
                        class: "nge-todo-btn nge-todo-add-btn",
                        onClick: _cache[100] || (_cache[100] = $event => ($setup.pickImages($setup.openCard)))
                      }, "🖼 Add an image"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_163, [
                    _createTextVNode("Checklist"),
                    ($setup.openCard.checklist.length)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString($setup.checkCount($setup.openCard).done) + "/" + _toDisplayString($setup.checkCount($setup.openCard).all), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("ul", _hoisted_164, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.openCard.checklist, (it, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: i,
                        class: _normalizeClass({ 'nge-todo-check--done': it.done })
                      }, [
                        _createElementVNode("label", null, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: it.done,
                            onChange: $event => ($setup.toggleItem($setup.openCard, i))
                          }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_165),
                          _createTextVNode(),
                          ($setup.itemOwner(it))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "nge-todo-avatar nge-todo-avatar--small",
                                style: _normalizeStyle({ background: $setup.itemColor(it) }),
                                title: 'For ' + $setup.itemName(it)
                              }, _toDisplayString($setup.itemName(it).slice(0, 1).toUpperCase()), 13 /* TEXT, STYLE, PROPS */, _hoisted_166))
                            : _createCommentVNode("v-if", true),
                          _createTextVNode(),
                          _createElementVNode("span", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parts(it.text), (pt, k) => {
                              return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                                (pt.tag)
                                  ? (_openBlock(), _createElementBlock("b", _hoisted_167, _toDisplayString(pt.t), 1 /* TEXT */))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                              ], 64 /* STABLE_FRAGMENT */))
                            }), 128 /* KEYED_FRAGMENT */))
                          ])
                        ]),
                        _createElementVNode("select", {
                          class: "nge-todo-item-owner",
                          value: it.owner_id || '',
                          "aria-label": "Who this item is for",
                          title: "Who this item is for",
                          onChange: $event => ($setup.setItem($setup.openCard, i, { owner_id: $setup.fieldValue($event) }))
                        }, [
                          _createElementVNode("option", _hoisted_169, _toDisplayString($setup.itemOwner(it) && !it.owner_id ? '@ in the text' : 'Nobody'), 1 /* TEXT */),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.people, (p) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: p.id,
                              value: p.id
                            }, _toDisplayString(p.name), 9 /* TEXT, PROPS */, _hoisted_170))
                          }), 128 /* KEYED_FRAGMENT */))
                        ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_168),
                        _createElementVNode("input", {
                          type: "date",
                          class: _normalizeClass(["nge-todo-item-due", { 'nge-todo-item-due--late': !it.done && it.due && it.due < $setup.todayIso() }]),
                          value: it.due || '',
                          "aria-label": "Due day",
                          title: "Due day",
                          onChange: $event => ($setup.setItem($setup.openCard, i, { due: $setup.fieldValue($event) }))
                        }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_171),
                        _createElementVNode("button", {
                          class: "nge-todo-mini",
                          title: "Comment on this item",
                          onClick: $event => ($setup.commentOn(it.text))
                        }, "💬 Comment", 8 /* PROPS */, _hoisted_172),
                        _createElementVNode("button", {
                          class: "nge-todo-mini",
                          title: "Remove this item",
                          "aria-label": "Remove",
                          onClick: $event => ($setup.removeItem($setup.openCard, i))
                        }, "×", 8 /* PROPS */, _hoisted_173)
                      ], 2 /* CLASS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createElementVNode("form", {
                    class: "nge-todo-row",
                    onSubmit: _cache[105] || (_cache[105] = _withModifiers($event => ($setup.addItem($setup.openCard)), ["prevent"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[101] || (_cache[101] = $event => (($setup.newItem) = $event)),
                      class: "nge-todo-input nge-todo-grow",
                      maxlength: "300",
                      placeholder: "Add an item",
                      "aria-label": "New checklist item",
                      onInput: _cache[102] || (_cache[102] = $event => ($setup.onMentionInput($event, v => $setup.newItem = v))),
                      onKeydown: $setup.onMentionKey,
                      onKeyup: _cache[103] || (_cache[103] = _withModifiers(() => {}, ["stop"])),
                      onKeypress: _cache[104] || (_cache[104] = _withModifiers(() => {}, ["stop"]))
                    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                      [_vModelText, $setup.newItem]
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      class: "nge-todo-btn",
                      disabled: !$setup.newItem.trim()
                    }, "Add", 8 /* PROPS */, _hoisted_174)
                  ], 32 /* HYDRATE_EVENTS */),
                  _hoisted_175,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.openCard.comments, (cm, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: i,
                      class: "nge-todo-comment"
                    }, [
                      _createElementVNode("div", _hoisted_176, _toDisplayString(cm.by) + " · " + _toDisplayString($setup.ago(cm.at)), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_177, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parts(cm.text), (pt, k) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: k }, [
                            (pt.href)
                              ? (_openBlock(), _createElementBlock("a", {
                                  key: 0,
                                  href: pt.href,
                                  target: "_blank",
                                  rel: "noopener noreferrer"
                                }, _toDisplayString(pt.t), 9 /* TEXT, PROPS */, _hoisted_178))
                              : (pt.tag)
                                ? (_openBlock(), _createElementBlock("b", _hoisted_179, _toDisplayString(pt.t), 1 /* TEXT */))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createTextVNode(_toDisplayString(pt.t), 1 /* TEXT */)
                                  ], 64 /* STABLE_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ]))
                  }), 128 /* KEYED_FRAGMENT */)),
                  _withDirectives(_createElementVNode("textarea", {
                    ref: "commentEl",
                    "onUpdate:modelValue": _cache[106] || (_cache[106] = $event => (($setup.comment) = $event)),
                    class: "nge-todo-input",
                    rows: "2",
                    maxlength: "2000",
                    placeholder: "Write a comment. Type @ to tag someone.",
                    "aria-label": "Comment",
                    onInput: _cache[107] || (_cache[107] = $event => ($setup.onMentionInput($event, v => $setup.comment = v))),
                    onKeydown: $setup.onMentionKey,
                    onKeyup: _cache[108] || (_cache[108] = _withModifiers(() => {}, ["stop"])),
                    onKeypress: _cache[109] || (_cache[109] = _withModifiers(() => {}, ["stop"]))
                  }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
                    [$setup["vAutogrow"]],
                    [_vModelText, $setup.comment]
                  ]),
                  ($setup.taggedPeople($setup.comment).length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                        _createTextVNode("Tagging "),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.taggedPeople($setup.comment), (p) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: p.id,
                            class: "nge-todo-tag-chip",
                            style: _normalizeStyle({ background: $setup.colorOf(p.id) })
                          }, "@" + _toDisplayString(p.name), 5 /* TEXT, STYLE */))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_181, [
                    _createElementVNode("button", {
                      class: "nge-todo-btn nge-todo-btn--primary",
                      disabled: $setup.busy || !$setup.comment.trim(),
                      onClick: _cache[110] || (_cache[110] = $event => ($setup.sendComment($setup.openCard)))
                    }, "Comment", 8 /* PROPS */, _hoisted_182),
                    ($setup.sentTags)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_183, "✓ " + _toDisplayString($setup.sentTags), 1 /* TEXT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  _createElementVNode("div", _hoisted_184, [
                    _createTextVNode(" Added by " + _toDisplayString($setup.openCard.created_by || 'someone') + ", " + _toDisplayString($setup.ago($setup.openCard.created_at)) + " ", 1 /* TEXT */),
                    _createElementVNode("button", {
                      class: "nge-todo-btn nge-todo-delete",
                      onClick: _cache[111] || (_cache[111] = $event => ($setup.deleteCard($setup.openCard)))
                    }, "Delete card")
                  ])
                ]))
              ]))
            : _createCommentVNode("v-if", true)
        ])),
    _createElementVNode("input", {
      ref: "imagePicker",
      type: "file",
      accept: "image/png,image/jpeg,image/gif,image/webp",
      multiple: "",
      hidden: "",
      onChange: $setup.onPicked
    }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */),
    _createCommentVNode(" The list of admins while typing a tag. "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      ($setup.mention && $setup.mentionMatches.length)
        ? (_openBlock(), _createElementBlock("ul", {
            key: 0,
            class: _normalizeClass(["nge-todo-mention", { 'nge-todo-mention--light': $props.light }]),
            role: "listbox",
            style: _normalizeStyle({ left: $setup.mention.el.getBoundingClientRect().left + 'px', top: $setup.mention.el.getBoundingClientRect().bottom + 4 + 'px' })
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mentionMatches, (p, i) => {
              return (_openBlock(), _createElementBlock("li", {
                key: p.id,
                role: "option",
                "aria-selected": i === $setup.mention.pick ? 'true' : 'false',
                class: _normalizeClass({ 'nge-todo-mention--pick': i === $setup.mention.pick }),
                onMousedown: _withModifiers($event => ($setup.pickMention(p)), ["prevent"])
              }, "@" + _toDisplayString(p.name), 43 /* TEXT, CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_185))
            }), 128 /* KEYED_FRAGMENT */))
          ], 6 /* CLASS, STYLE */))
        : _createCommentVNode("v-if", true)
    ]))
  ], 2 /* CLASS */))
}